import { FeathersModel } from 'src/app/models/feathersModel'
import { TreeNode } from 'primeng/api'

export class IPJournalCloneForm extends FeathersModel {
  static serviceName = 'features/client-ip/copy-ip-entries'

  clientIds: number[]
  IPEntriesSelect: TreeNode[]
}
